<span *ngIf="numberOfFiles != null">{{ numberOfFiles + ' ' + ((numberOfFiles === 1 ? 'GENERAL.FILE' : 'GENERAL.FILES') | translate) }}</span>
